import React from 'react';

const LoadingSpinner = ({ size = 'medium', className = '' }) => {
    const sizeClasses = {
        small: 'h-4 w-4',
        medium: 'h-6 w-6',
        large: 'h-8 w-8',
        xl: 'h-12 w-12'
    };

    return (
        <div className={`flex items-center justify-center ${className}`}>
            <div className={`loading-spinner ${sizeClasses[size]}`}></div>
        </div>
    );
};

export default LoadingSpinner;

